/**
 * Layout constants used across the application
 */

/**
 * The padding value (in pixels) used in the workspace layout.
 * This is applied as p-3 (12px) on top and bottom = 24px total.
 */
export const WORKSPACE_PADDING_PX = 24;

/**
 * CSS height value for pages inside the workspace layout that have padding.
 * Use this for loading states and full-height containers.
 */
export const WORKSPACE_CONTENT_HEIGHT = `calc(100vh - ${WORKSPACE_PADDING_PX}px)`;
